import { isDMM } from "libs/dmm";
import * as React from "react";
import { PageProps } from "gatsby";
import { DMMPopupContextProvider } from "hooks/useDMMPopupState";
import { Copyright } from "components/Copyright";
import { AgeWarningModal } from "components/AgeWarningModal";
import { Header } from "components/Header";
import { DMMPopup } from "components/DMMPopup";
import { Seo } from "components/Seo";

export default function Root({
    pageContext,
    children,
}: PageProps<null, { layout: string; language: string }>) {

    if (pageContext.layout === "no-layout") return <>{children}</>;

    return (
        <DMMPopupContextProvider>
            <Seo />
            <Header />
            {children}
            <Copyright />
            <AgeWarningModal />
            {isDMM && <DMMPopup />}
        </DMMPopupContextProvider>
    );
}
